import { useCorridorPublicAPI } from "@/composables/useCorridorPublicAPI.js";

export const useCorridorStatus = () => {
    const corridorPublicAPI = useCorridorPublicAPI();

    const execute = async ({ onSuccess: onSuccess, onError: onError } = {}) => {
        try {
            const response = await corridorPublicAPI.get("/status");
            if (onSuccess) {
                onSuccess(response);
            }
        } catch (error) {
            if (onError) {
                onError(error);
            }
        }
    };

    return { execute };
};
